import { render, staticRenderFns } from "./trainerDashboard.vue?vue&type=template&id=145e24d8&scoped=true"
import script from "./trainerDashboard.vue?vue&type=script&lang=js"
export * from "./trainerDashboard.vue?vue&type=script&lang=js"
import style0 from "./trainerDashboard.vue?vue&type=style&index=0&id=145e24d8&prod&scoped=true&lang=css"
import style1 from "./trainerDashboard.vue?vue&type=style&index=1&id=145e24d8&prod&lang=css"
import style2 from "./trainerDashboard.vue?vue&type=style&index=2&id=145e24d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e24d8",
  null
  
)

export default component.exports